import React from "react";

const TaskSummaryCards = ({ cards = [] }) => {
  if (!cards.length) return null;

  return (
    <div className="task-summary-cards">
      {cards.map((card) => (
        <div className="task-summary-card" key={card.key}>
          <span className="task-summary-card-label">{card.label}</span>
          <span className="task-summary-card-value">{card.value}</span>
          <span className={`task-summary-card-sub${card.tone ? ` tone-${card.tone}` : ""}`}>
            {card.subtitle}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TaskSummaryCards;
